import { isResourceDetailVideo, isResourceDetailAudio } from './resourceDetailGuards.js';

const getResourceDuration = (resource) => {
  if (isResourceDetailVideo(resource)) {
    return resource.data.attributes?.video?.duration;
  }
  if (isResourceDetailAudio(resource)) {
    return resource.data.attributes?.audio?.duration;
  }
  return null;
};

export { getResourceDuration };
//# sourceMappingURL=getResourceDuration.js.map
